import React, { useState } from 'react';
import { markerStyles } from './MarkerStyles';
import { stripHtml } from '../adminAyarlar/shared/utils';

const MarkerListPanel = ({ markers = [], onDeleteMarker }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(true);

  // Marker'ları arama terimine göre filtrele
  const filteredMarkers = markers.filter(marker => {
    const eventTitle = stripHtml(marker.storyEvent_id?.title || '');
    return eventTitle.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <>
      {/* Açma/Kapama Butonu */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed right-0 top-1/2 -translate-y-1/2 z-30 bg-white border border-gray-300 border-r-0 rounded-l-lg px-1 py-3 shadow-md hover:bg-gray-100 transition-all"
        style={{ right: isOpen ? '288px' : '0' }}
        title={isOpen ? 'İşaretleyicileri Kapat' : 'İşaretleyicileri Aç'}
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="w-4 h-4 text-gray-600">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? 'M9 5l7 7-7 7' : 'M15 19l-7-7 7-7'} />
        </svg>
      </button>

      {/* Panel */}
      <div
        className="fixed right-0 top-0 h-full z-20 bg-white border-l border-gray-200 shadow-lg transition-transform duration-300"
        style={{ width: '288px', transform: isOpen ? 'translateX(0)' : 'translateX(100%)' }}
      >
        <div className="p-4 h-full flex flex-col">
          <h2 className="text-lg font-semibold mb-3">İşaretleyiciler</h2>
          <input
            type="text"
            placeholder="Olay adına göre ara..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="w-full px-3 py-2 mb-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
          />
          <div className="flex-1 overflow-y-auto space-y-2">
        {filteredMarkers.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            {markers.length === 0 ? 'Henüz işaretleyici eklenmemiş' : 'İşaretleyici bulunamadı'}
          </div>
        ) : (
          filteredMarkers.map(marker => (
            <div key={marker._id} className="flex items-center justify-between p-2 border rounded-lg bg-gray-50">
              <div className="flex items-center space-x-2">
                {/* Renk göstergesi */}
                {marker.color && (
                  <span className="w-3 h-3 rounded-full inline-block" style={{ backgroundColor: marker.color }} />
                )}
                <span className="text-sm font-medium truncate max-w-[100px]">
                  {stripHtml(marker.storyEvent_id?.title || 'Olay Yok')}
                </span>
                <span className="text-xs text-gray-400">({markerStyles.find(style => style.type === marker.type).name})</span>
              </div>
              <button
                onClick={() => onDeleteMarker(marker._id)}
                className="ml-2 px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600"
              >
                Sil
              </button>
            </div>
          ))
        )}
      </div>
        </div>
      </div>
    </>
  );
};

export default MarkerListPanel; 